import { getNextStaticProps } from "@faustjs/next";
import { client, PageIdType } from "../client";
import { GetStaticPropsContext } from "next";
import {
  LargeWorkCard,
  SmallWorkCard,
  CEOLink,
  GenericDivider,
  FeaturedPost,
} from "components";
import { useMenu, useGeneralOptionsSettings, useFeaturedPost } from "hooks";
import Layout from "layouts/main";

export default function Page() {
  const { useQuery } = client;
  const { usePage } = client;
  const featuredPost = useFeaturedPost();
  const works = useQuery().works({ first: 50 }).nodes;
  const headerLinks = useMenu("PRIMARY");
  const footerLinks = useMenu("FOOTER");
  const page = usePage({
    id: `/work`,
    idType: PageIdType.URI,
  });

  const options = useGeneralOptionsSettings();
  const ceoLink = options?.generalSettings?.ceoLink;
  const colors = ["blue", "red", "yellow", "green"];

  return (
    <Layout page={page} headerLinks={headerLinks} footerLinks={footerLinks}>
      <section className="section-container w-full mx-auto">
        <div className="content-container flex flex-col justify-start items-start mx-auto">
          <h1 className="h2 text-black ml-2 sm:ml-4 mt-20 mb-20 sm:mb-10">
            Work
          </h1>
          <div className="flex flex-col justify-center items-center text-left relative max-w-full">
            {works.slice(0, 4).map((work) => (
              <LargeWorkCard
                key={work.id}
                work={work}
                showTitle={true}
                className="md:mb-52"
              />
            ))}
            <div className="flex flex-col justify-start items-center sm:items-center text-left gap-12 mb-12 md:mb-24 max-w-6xl w-[90vw] sm:w-full">
              <GenericDivider />
              {/* <h2 className="h2 self-start justify-self-start">
                But wait, there&apos;s more:
              </h2> */}
            </div>
            <div className="grid gap-x-24 gap-y-20 grid-cols-1 place-items-center lg:place-items-start place-content-center lg:grid-cols-2 lg:grid-rows-2">
              {works.slice(4).map((work, index) => (
                <SmallWorkCard
                  key={work.id}
                  work={work}
                  color={`bg-${colors[index % 4]}`}
                />
              ))}
            </div>
          </div>

          <CEOLink
            className="h-[70px] w-[271px] fixed bottom-5 right-5 z-50"
            link={ceoLink}
          />
        </div>
      </section>
      <FeaturedPost post={featuredPost} />
    </Layout>
  );
}

export async function getStaticProps(context: GetStaticPropsContext) {
  return getNextStaticProps(context, {
    Page,
    client,
  });
}
